define('home/views/HomepageChannelsModuleView',[
    'underscore',

    'core/strings',

    'home/views/ChannelsModuleView',
    'home/views/ChannelSuggestionView',
    'home/templates/homepageChannelsModule',
], function (
    _,

    strings,

    ChannelsModuleView,
    ChannelSuggestionView,
    homepageChannelsModuleTemplate
) {
    'use strict';

    var gettext = strings.get;

    /**
     * An enclosed module that shows a list of channels.
     * Expects a collection of ChannelProfiles or Channels
     */
    var HomepageChannelsModuleView = ChannelsModuleView.extend({
        className: 'aside__wrap -padded',

        template: homepageChannelsModuleTemplate,
        templateHelpers: {
            moduleTitle: gettext('Lively Channels'),
        },

        itemView: ChannelSuggestionView,
        itemViewOptions: function (item, index) {
            var existing = ChannelsModuleView.prototype.itemViewOptions;
            if (_.isFunction(existing))
                existing = existing.call(this, item, index);

            return _.defaults({
                className: 'recommended-wrap',
            }, existing);
        },
    });

    return HomepageChannelsModuleView;
});

